import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  FaCar, FaFileAlt, FaSearch, FaPrint, FaEdit, FaTrash,
  FaCalendarAlt, FaUser, FaIdCard, FaTimesCircle,
  FaMoneyBillWave, FaPlus, FaFileExport, FaFilter,
  FaCalendarDay, FaCalendarWeek, FaSync,
  FaWallet,
  FaChevronLeft, FaChevronRight, FaStepBackward, FaStepForward,
  FaCheckDouble, FaBan, FaExclamationTriangle, FaEye, FaFilePdf
} from 'react-icons/fa';
import Header from '../others/Header';
import config from '../config/config';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { useToast } from '../components/ToastContext';
import ConfirmModal from '../components/ConfirmModal';
import { decodeToken } from 'react-jwt';

Modal.setAppElement('#root');

function OrdemServicoView() {
  const { API_BASE_URL } = config;
  const navigate = useNavigate();

  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      const decoded = decodeToken(token);
      setUserRole((decoded?.tipoUsuario || '').toUpperCase());
    }
  }, []);

  const podeEditar = ['MANAGER', 'GERENTE', 'ADMIN'].includes(userRole);

  const [ordens, setOrdens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [ordensFiltradas, setOrdensFiltradas] = useState([]);
  const [valorConfirm, setValorConfirm] = useState('Excluir');
  const [motivosPorId, setMotivosPorId] = useState({});

  // ── Contadores (Qtd. O.S. / NFS-e geradas / O.S. em aberto / NFS-e c/ erro / O.S. canceladas) ──
  // Calculados no backend, sempre seguindo o MESMO filtro aplicado na lista
  // (período + nome/CPF/CNPJ) - não ficam fixos em "hoje".
  // O filtro de status é ignorado de propósito: os contadores já mostram a
  // composição por status, filtrar por status junto seria redundante.
  const [contadores, setContadores] = useState({ totalOS: 0, nfseGeradas: 0, osAbertas: 0, nfseComErro: 0, osCanceladas: 0 });
  const [carregandoContadores, setCarregandoContadores] = useState(true);

  // ── Modal finalização individual (agora só confirmação, sem forma de pagamento) ──
  const [modalFinalizacaoIsOpen, setModalFinalizacaoIsOpen] = useState(false);
  const [ordemParaFinalizar, setOrdemParaFinalizar] = useState(null);
  const [finalizandoOrdem, setFinalizandoOrdem] = useState(false);

  // ── Modal "Finalizar Todas as Ordens do Dia" - emite a NFS-e de cada
  // ordem em aberto de hoje, sempre o dia em que o botão for clicado ──────
  const [modalFinalizarTodasAberto, setModalFinalizarTodasAberto] = useState(false);
  const [loadingFinalizarTodas, setLoadingFinalizarTodas] = useState(false);

  // ── Modal cancelamento ────────────────────────────────────────────────────
  const [modalCancelamentoAberto, setModalCancelamentoAberto] = useState(false);
  const [ordemParaCancelar, setOrdemParaCancelar] = useState(null);
  const [motivoCancelamento, setMotivoCancelamento] = useState('');
  const [loadingCancelamento, setLoadingCancelamento] = useState(false);

  // ── Modal cancelamento de NFS-e (só habilitado com a OS CONCLUIDA) ─────────
  const [modalCancelamentoNfseAberto, setModalCancelamentoNfseAberto] = useState(false);
  const [ordemParaCancelarNfse, setOrdemParaCancelarNfse] = useState(null);
  const [cMotivoNfse, setCMotivoNfse] = useState('1');
  const [xMotivoNfse, setXMotivoNfse] = useState('');
  const [loadingCancelamentoNfse, setLoadingCancelamentoNfse] = useState(false);

  // Cancelamento MANUAL de NFS-e - escape valve que aparece dentro do mesmo
  // modal quando o cancelamento automático acima falha (ex.: P1001 do
  // Cidade360, "está parametrizado para requisitar aprovação desta
  // operação" - trava só o canal de API, o contribuinte consegue cancelar
  // direto no portal da prefeitura). Não chama o provedor, só registra o
  // estado no Nexus com o protocolo do requerimento como lastro.
  const [erroCancelamentoNfse, setErroCancelamentoNfse] = useState(null);
  const [protocoloCancelamentoManual, setProtocoloCancelamentoManual] = useState('');
  const [loadingCancelamentoManual, setLoadingCancelamentoManual] = useState(false);

  // Guarda `${idOrdem}:visualizar` ou `${idOrdem}:danfse` enquanto a
  // requisição estiver em andamento, para desabilitar só o botão clicado.
  const [nfseAcaoEmAndamento, setNfseAcaoEmAndamento] = useState(null);

  // Mapa { idOrdem: mensagemDeErro } - preenchido quando visualizar/gerar
  // DANFSe/cancelar a NFS-e falha, pra destacar o card e permitir ver o
  // erro completo depois (em vez de só o toast, que some sozinho). Limpo
  // quando alguma dessas ações dá certo pra aquela OS.
  const [nfseErroPorId, setNfseErroPorId] = useState({});
  const [modalErroNfseAberto, setModalErroNfseAberto] = useState(false);
  const [erroNfseSelecionado, setErroNfseSelecionado] = useState(null);

  // Campos digitados nos filtros (só valem depois de "Buscar")
  const [filtroCpfCnpj, setFiltroCpfCnpj] = useState('');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('TODOS');
  // Filtros efetivamente aplicados na lista e nos contadores - período,
  // nome/CPF/CNPJ e status vão JUNTOS para o backend (/ordemservico/busca).
  // Sem período e sem nome/CPF/CNPJ = ordens de hoje.
  const [filtrosAplicados, setFiltrosAplicados] = useState({ dataInicio: '', dataFim: '', termo: '', status: 'TODOS' });
  // Descarta respostas antigas quando o usuário troca o filtro antes da
  // requisição anterior terminar (senão a lista podia mostrar o filtro velho).
  const ultimaBuscaOrdens = useRef(0);
  const ultimaBuscaContadores = useRef(0);
  const { addToast } = useToast();

  const [confirmModal, setConfirmModal] = useState({ isOpen: false, message: '', onConfirm: () => {}, title: 'Confirmação' });
  const [paginaAtual, setPaginaAtual] = useState(0);
  const [tamanhoPagina, setTamanhoPagina] = useState(50);
  const [totalPaginas, setTotalPaginas] = useState(0);
  const [totalElementos, setTotalElementos] = useState(0);

  const showConfirm = (message, onConfirm, title = 'Confirmação') => setConfirmModal({ isOpen: true, message, onConfirm, title });
  const closeConfirm = () => setConfirmModal({ isOpen: false, message: '', onConfirm: () => {}, title: 'Confirmação' });

  const getAuthHeader = () => ({ headers: { 'Authorization': `Bearer ${localStorage.getItem('jwtToken')}` } });

  // Retorna a data local no formato yyyy-MM-dd sem offset de fuso horário
  const dataLocalHoje = () => {
    const hoje = new Date();
    const ano  = hoje.getFullYear();
    const mes  = String(hoje.getMonth() + 1).padStart(2, '0');
    const dia  = String(hoje.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  // Monta os parâmetros da busca combinada. Sem período e sem nome/CPF/CNPJ
  // = ordens de hoje (comportamento padrão da tela). Só nome/CPF/CNPJ = todas
  // as datas daquele cliente.
  const montarParamsBusca = (filtros, comStatus) => {
    const params = new URLSearchParams();
    const termo = (filtros.termo || '').trim();
    if (filtros.dataInicio && filtros.dataFim) {
      params.set('dataInicio', filtros.dataInicio);
      params.set('dataFim', filtros.dataFim);
    } else if (!termo) {
      params.set('dataInicio', dataLocalHoje());
      params.set('dataFim', dataLocalHoje());
    }
    if (termo) params.set('termo', termo);
    if (comStatus && filtros.status && filtros.status !== 'TODOS') params.set('status', filtros.status);
    return params;
  };

  const carregarOrdens = async (pagina = paginaAtual, filtros = filtrosAplicados, tamanho = tamanhoPagina) => {
    const idBusca = ++ultimaBuscaOrdens.current;
    try {
      setLoading(true);
      const params = montarParamsBusca(filtros, true);
      params.set('page', pagina);
      params.set('size', tamanho);
      const response = await axios.get(`${API_BASE_URL}/ordemservico/busca/pagina?${params.toString()}`, getAuthHeader());
      if (idBusca !== ultimaBuscaOrdens.current) return; // chegou uma busca mais nova
      const dadosPagina = response.data;

      const ordens = dadosPagina.content;
      setOrdens(ordens);
      setOrdensFiltradas(ordens);
      setTotalPaginas(dadosPagina.totalPages);
      setTotalElementos(dadosPagina.totalElements);
      setPaginaAtual(dadosPagina.number);

      // Busca motivo individualmente para cada ordem CANCELADA
      // (o DTO de listagem não retorna o campo motivoCancelamento)
      const canceladas = ordens.filter(o => o.statusOrdemServico === 'CANCELADA');
      if (canceladas.length > 0) {
        const token = localStorage.getItem('jwtToken');
        const headers = { headers: { 'Authorization': `Bearer ${token}` } };
        const motivosMap = {};
        await Promise.all(
          canceladas.map(async (ordem) => {
            try {
              const res = await axios.get(`${API_BASE_URL}/ordemservico/${ordem.id}`, headers);
              motivosMap[ordem.id] = res.data?.motivoCancelamento || null;
            } catch {
              motivosMap[ordem.id] = null;
            }
          })
        );
        setMotivosPorId(prev => ({ ...prev, ...motivosMap }));
      }
    } catch (err) {
      if (idBusca !== ultimaBuscaOrdens.current) return;
      setError(err.response?.data?.message || 'Erro ao carregar ordens de serviço');
    } finally {
      if (idBusca === ultimaBuscaOrdens.current) setLoading(false);
    }
  };

  // ── Contadores ────────────────────────────────────────────────────────
  // Contados no banco (GET /ordemservico/busca/contadores) com o mesmo
  // período + nome/CPF/CNPJ da lista - sem limite de quantidade e sem o
  // filtro de status (os contadores já mostram a composição por status).
  // - Qtd. O.S.        -> total de ordens no filtro atual (qualquer status)
  // - NFS-e geradas     -> statusNfse === 'AUTORIZADA'
  // - O.S. em aberto    -> statusOrdemServico === 'ABERTA'
  // - NFS-e c/ erro      -> ABERTA com erroNfse preenchido
  // - O.S. canceladas   -> statusOrdemServico === 'CANCELADA'
  const carregarContadores = async (filtros = filtrosAplicados) => {
    const idBusca = ++ultimaBuscaContadores.current;
    setCarregandoContadores(true);
    try {
      const params = montarParamsBusca(filtros, false);
      const response = await axios.get(`${API_BASE_URL}/ordemservico/busca/contadores?${params.toString()}`, getAuthHeader());
      if (idBusca !== ultimaBuscaContadores.current) return;
      setContadores(response.data);
    } catch {
      // Contadores não são críticos para a tela funcionar - falha silenciosa
    } finally {
      if (idBusca === ultimaBuscaContadores.current) setCarregandoContadores(false);
    }
  };

  const irParaPagina = (pagina) => { setPaginaAtual(pagina); carregarOrdens(pagina); };
  const avancarPagina = () => { if (paginaAtual < totalPaginas - 1) irParaPagina(paginaAtual + 1); };
  const retrocederPagina = () => { if (paginaAtual > 0) irParaPagina(paginaAtual - 1); };
  const irParaPrimeiraPagina = () => irParaPagina(0);
  const irParaUltimaPagina = () => irParaPagina(totalPaginas - 1);
  const alterarTamanhoPagina = (novoTamanho) => { setTamanhoPagina(novoTamanho); setPaginaAtual(0); };

  useEffect(() => { carregarOrdens(0); }, [tamanhoPagina]);
  useEffect(() => { carregarContadores(); }, []);

  // Aplica período + nome/CPF/CNPJ + status juntos (sempre voltando pra
  // página 1). Filtros passados explicitamente pra não depender do estado
  // ainda não atualizado pelo React.
  const aplicarFiltros = (sobrescrever = {}) => {
    const filtros = {
      dataInicio, dataFim,
      termo: filtroCpfCnpj.trim(),
      status: filtroStatus,
      ...sobrescrever,
    };
    if ((filtros.dataInicio && !filtros.dataFim) || (!filtros.dataInicio && filtros.dataFim)) {
      addToast('warning', 'Preencha as duas datas do período'); return;
    }
    if (filtros.dataInicio && filtros.dataFim) {
      if (filtros.dataInicio > filtros.dataFim) { addToast('warning', 'A data inicial não pode ser maior que a final.'); return; }
      if (!validarPeriodo(filtros.dataInicio, filtros.dataFim)) { addToast('warning', 'O período não pode ser superior a 90 dias.'); return; }
    }
    setFiltrosAplicados(filtros);
    setPaginaAtual(0);
    carregarOrdens(0, filtros);
    carregarContadores(filtros);
  };

  const validarPeriodo = (inicio, fim) => {
    const diffDays = Math.ceil(Math.abs(new Date(fim) - new Date(inicio)) / (1000 * 60 * 60 * 24));
    return diffDays <= 90;
  };

  const alterarFiltroStatus = (status) => { setFiltroStatus(status); aplicarFiltros({ status }); };

  const filtrarOrdensDeHoje = () => {
    const hoje = dataLocalHoje();
    setDataInicio(hoje);
    setDataFim(hoje);
    aplicarFiltros({ dataInicio: hoje, dataFim: hoje });
  };

  const limparFiltros = () => {
    setFiltroCpfCnpj(''); setDataInicio(''); setDataFim(''); setFiltroStatus('TODOS');
    aplicarFiltros({ dataInicio: '', dataFim: '', termo: '', status: 'TODOS' });
  };

  const periodoAplicado = filtrosAplicados.dataInicio && filtrosAplicados.dataFim;
  const mostrandoHoje = !filtrosAplicados.termo && (!periodoAplicado
    || (filtrosAplicados.dataInicio === dataLocalHoje() && filtrosAplicados.dataFim === dataLocalHoje()));
  const temFiltroAplicado = !!(periodoAplicado || filtrosAplicados.termo || filtrosAplicados.status !== 'TODOS');
  const formatarData = (dataString) => {
    if (!dataString) return '';
    // Evita offset de fuso horário ao interpretar datas sem horário como UTC
    const [ano, mes, dia] = String(dataString).split('T')[0].split('-');
    return `${dia}/${mes}/${ano}`;
  };
  const editarOrdem = (id) => navigate(`/criar-editar-ordemServico/${id}`);
  const novaOrdem = () => navigate('/criar-editar-ordemServico');

  const excluirOrdem = async (id) => {
    setValorConfirm('Excluir Ordem');
    showConfirm('Tem certeza que deseja excluir esta ordem de serviço?', async () => {
      try { await axios.delete(`${API_BASE_URL}/ordemservico/${id}`, getAuthHeader()); carregarOrdens(); }
      catch (err) { addToast('error', 'Erro ao excluir: ' + (err.response?.data?.message || err.message)); }
    }, 'Excluir Ordem de serviço');
  };

  const imprimirOrdem = async (id) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/ordemservico/recibo/${id}`, { ...getAuthHeader(), responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const newWindow = window.open(url, '_blank');
      if (!newWindow) {
        const link = document.createElement('a');
        link.href = url;
        link.download = `ordem-servico-${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (error) { addToast('error', 'Erro ao abrir PDF: ' + error.message); }
  };

  // ── Cancelamento com motivo ───────────────────────────────────────────────
  const abrirModalCancelamento = (ordem) => {
    setOrdemParaCancelar(ordem);
    setMotivoCancelamento('');
    setModalCancelamentoAberto(true);
  };

  const fecharModalCancelamento = () => {
    setModalCancelamentoAberto(false);
    setOrdemParaCancelar(null);
    setMotivoCancelamento('');
  };

  const confirmarCancelamento = async () => {
    if (!motivoCancelamento.trim()) { addToast('warning', 'Informe o motivo do cancelamento'); return; }
    setLoadingCancelamento(true);
    try {
      await axios.put(
        `${API_BASE_URL}/ordemservico/${ordemParaCancelar.id}/status`,
        { status: 'CANCELADA', motivo_cancelamento: motivoCancelamento.trim() },
        getAuthHeader()
      );
      addToast('success', 'Ordem cancelada com sucesso!');
      fecharModalCancelamento();
      carregarOrdens();
      carregarContadores();
    } catch (err) {
      addToast('error', 'Erro ao cancelar: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingCancelamento(false);
    }
  };

  const alterarSatusOrdem = async (id, novoStatus) => {
    try { await axios.put(`${API_BASE_URL}/ordemservico/${id}/status`, { status: novoStatus }, getAuthHeader()); carregarOrdens(); }
    catch (err) { addToast('error', 'Erro ao alterar status: ' + (err.response?.data?.message || err.message)); }
  };

  // ── NFS-e: Visualizar / Cancelar / Imprimir DANFSe ──────────────────────
  // (botões habilitados só para ordens CONCLUIDA - ver OrdemServicoController
  // /ordemservico/{id}/nfse, /nfse/cancelar e /nfse/danfse)

  const abrirBlobEmNovaAba = (blob, filenameFallback) => {
    const url = window.URL.createObjectURL(blob);
    const newWindow = window.open(url, '_blank');
    if (!newWindow) {
      const link = document.createElement('a');
      link.href = url;
      link.download = filenameFallback;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  };

  // Com responseType 'blob', a resposta de erro (422 com {"message": "..."})
  // também vem como Blob em vez de JSON - precisa ler o texto antes de parsear.
  const extrairMensagemErroBlob = async (err) => {
    try {
      const blob = err.response?.data;
      if (blob instanceof Blob) {
        const texto = await blob.text();
        return JSON.parse(texto)?.message;
      }
    } catch (_) { /* resposta não era JSON - cai no fallback abaixo */ }
    return err.response?.data?.message || err.message;
  };

  // Marca/limpa o erro de NFS-e de uma OS específica - controla o destaque
  // visual do card (fundo) e o botão "Ver erro" (abre erroNfseSelecionado).
  const marcarErroNfse = (id, mensagem) => setNfseErroPorId(prev => ({ ...prev, [id]: mensagem }));
  const limparErroNfse = (id) => setNfseErroPorId(prev => {
    if (!(id in prev)) return prev;
    const proximo = { ...prev };
    delete proximo[id];
    return proximo;
  });

  // mensagem explícita: usado tanto pro erro de uma ação (visualizar/DANFSe/
  // cancelar, guardado só localmente em nfseErroPorId) quanto pro erro de
  // emissão (persistido em ordem.erroNfse, vindo do backend).
  const abrirModalErroNfse = (ordem, mensagem) => {
    setErroNfseSelecionado({ ordem, mensagem });
    setModalErroNfseAberto(true);
  };
  const fecharModalErroNfse = () => { setModalErroNfseAberto(false); setErroNfseSelecionado(null); };

  const visualizarNfse = async (id) => {
    setNfseAcaoEmAndamento(`${id}:visualizar`);
    try {
      const response = await axios.get(`${API_BASE_URL}/ordemservico/${id}/nfse`, { ...getAuthHeader(), responseType: 'blob' });
      abrirBlobEmNovaAba(new Blob([response.data], { type: 'application/xml' }), `nfse-os-${id}.xml`);
      limparErroNfse(id);
    } catch (err) {
      const mensagem = (await extrairMensagemErroBlob(err)) || 'Erro ao visualizar a NFS-e.';
      marcarErroNfse(id, mensagem);
      addToast('error', mensagem);
    } finally {
      setNfseAcaoEmAndamento(null);
    }
  };

  const imprimirDanfseNfse = async (id) => {
    setNfseAcaoEmAndamento(`${id}:danfse`);
    try {
      const response = await axios.get(`${API_BASE_URL}/ordemservico/${id}/nfse/danfse`, { ...getAuthHeader(), responseType: 'blob' });
      abrirBlobEmNovaAba(new Blob([response.data], { type: 'application/pdf' }), `danfse-os-${id}.pdf`);
      limparErroNfse(id);
    } catch (err) {
      const mensagem = (await extrairMensagemErroBlob(err)) || 'Erro ao gerar o DANFSe.';
      marcarErroNfse(id, mensagem);
      addToast('error', mensagem);
    } finally {
      setNfseAcaoEmAndamento(null);
    }
  };

  const abrirModalCancelamentoNfse = (ordem) => {
    setOrdemParaCancelarNfse(ordem);
    setCMotivoNfse('1');
    setXMotivoNfse('');
    setErroCancelamentoNfse(null);
    setProtocoloCancelamentoManual('');
    setModalCancelamentoNfseAberto(true);
  };

  const fecharModalCancelamentoNfse = () => {
    if (loadingCancelamentoNfse || loadingCancelamentoManual) return;
    setModalCancelamentoNfseAberto(false);
    setOrdemParaCancelarNfse(null);
    setXMotivoNfse('');
    setErroCancelamentoNfse(null);
    setProtocoloCancelamentoManual('');
  };

  const confirmarCancelamentoNfse = async () => {
    if (xMotivoNfse.trim().length < 15) { addToast('warning', 'O motivo deve ter pelo menos 15 caracteres'); return; }
    const idOrdem = ordemParaCancelarNfse.id;
    setLoadingCancelamentoNfse(true);
    setErroCancelamentoNfse(null);
    try {
      await axios.post(
        `${API_BASE_URL}/ordemservico/${idOrdem}/nfse/cancelar`,
        { cMotivo: cMotivoNfse, xMotivo: xMotivoNfse.trim() },
        getAuthHeader()
      );
      addToast('success', 'NFS-e cancelada com sucesso!');
      limparErroNfse(idOrdem);
      fecharModalCancelamentoNfse();
      carregarOrdens(); // atualiza statusNfse pra CANCELADA e some com os botões
      carregarContadores();
    } catch (err) {
      const mensagem = err.response?.data?.message || err.message;
      marcarErroNfse(idOrdem, mensagem);
      // Não fecha o modal: mantém o motivo preenchido e libera a opção de
      // cancelamento manual abaixo, pro caso do provedor ter rejeitado o
      // cancelamento via API mas o cancelamento direto no portal da
      // prefeitura continuar disponível (ex.: P1001 do Cidade360).
      setErroCancelamentoNfse(mensagem);
      addToast('error', 'Erro ao cancelar NFS-e: ' + mensagem);
    } finally {
      setLoadingCancelamentoNfse(false);
    }
  };

  const confirmarCancelamentoManualNfse = async () => {
    if (xMotivoNfse.trim().length < 15) { addToast('warning', 'O motivo deve ter pelo menos 15 caracteres'); return; }
    if (protocoloCancelamentoManual.trim().length === 0) { addToast('warning', 'Informe o número do protocolo/requerimento junto à prefeitura'); return; }
    const idOrdem = ordemParaCancelarNfse.id;
    setLoadingCancelamentoManual(true);
    try {
      await axios.post(
        `${API_BASE_URL}/ordemservico/${idOrdem}/nfse/confirmar-cancelamento-manual`,
        { xMotivo: xMotivoNfse.trim(), protocolo: protocoloCancelamentoManual.trim() },
        getAuthHeader()
      );
      addToast('success', 'Cancelamento manual registrado com sucesso!');
      limparErroNfse(idOrdem);
      fecharModalCancelamentoNfse();
      carregarOrdens();
      carregarContadores();
    } catch (err) {
      const mensagem = err.response?.data?.message || err.message;
      addToast('error', 'Erro ao registrar cancelamento manual: ' + mensagem);
    } finally {
      setLoadingCancelamentoManual(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'ABERTA':    return { bg: '#E3F2FD', text: '#0D47A1' };
      case 'CONCLUIDA': return { bg: '#E8F5E9', text: '#2E7D32' };
      case 'EM_ANALISE':return { bg: '#FFF8E1', text: '#FF8F00' };
      case 'CANCELADA': return { bg: '#FFEBEE', text: '#C62828' };
      case 'PENDENTE':  return { bg: '#F3E5F5', text: '#6A1B9A' };
      default:          return { bg: '#ECEFF1', text: '#37474F' };
    }
  };

  // ── Finalização individual: agora é só confirmação, sem forma de pagamento ──
  const abrirModalFinalizacao = (ordem) => { setOrdemParaFinalizar(ordem); setModalFinalizacaoIsOpen(true); };
  const fecharModalFinalizacao = () => { if (finalizandoOrdem) return; setModalFinalizacaoIsOpen(false); setOrdemParaFinalizar(null); };

  const finalizarOrdem = async () => {
    const idOrdem = ordemParaFinalizar.id;
    setFinalizandoOrdem(true);
    try {
      const response = await axios.put(`${API_BASE_URL}/ordemservico/${idOrdem}/finalizarOrdemServico`, {}, getAuthHeader());
      const numeroNfse = response.data?.numeroNfse;
      addToast('success', numeroNfse ? `Ordem finalizada! NFS-e emitida (chave de acesso ${numeroNfse}).` : 'Ordem finalizada!');
      setModalFinalizacaoIsOpen(false);
      setOrdemParaFinalizar(null);
      carregarOrdens();
      carregarContadores();
    } catch (err) {
      // Confirmacao real (nao um "assume sucesso"): cobre o caso da resposta
      // do PUT se perder na rede mesmo com a OS tendo sido finalizada no servidor.
      try {
        const verificacao = await axios.get(`${API_BASE_URL}/ordemservico/${idOrdem}`, getAuthHeader());
        if (verificacao.data?.statusOrdemServico === 'CONCLUIDA') {
          addToast('success', 'Ordem finalizada!');
          setModalFinalizacaoIsOpen(false);
          setOrdemParaFinalizar(null);
          carregarOrdens();
          carregarContadores();
          return;
        }
      } catch (_) {}
      // err.response.data.message traz a mensagem de rejeicao do SEFIN
      // Nacional quando a NFS-e e recusada ao finalizar a OS.
      addToast('error', err.response?.data?.message || err.message || 'Erro ao finalizar a ordem de serviço.');
      // A falha de emissão fica persistida em ordem.erroNfse (OS continua
      // ABERTA) - recarrega a lista pra destacar o card com o botão "Ver
      // erro da NFS-e", em vez do erro só existir no toast que já sumiu.
      carregarOrdens();
      carregarContadores();
    } finally {
      setFinalizandoOrdem(false);
    }
  };

  // ── Finalizar todas as ordens de HOJE, emitindo a NFS-e de cada uma
  // (mesma lógica do "Finalizar" individual, só que em lote) - só opera no
  // dia em que for clicado, sem seletor de data: PUT /ordemservico/
  // finalizarOrdemServicoDoDia não aceita parâmetro nenhum. Uma OS com erro
  // de emissão não trava as demais - continua ABERTA com o erro registrado,
  // pronta pra reenviar depois (Área Fiscal ou reabrindo a OS). ──────────
  const abrirModalFinalizarTodas = () => { setModalFinalizarTodasAberto(true); };
  const fecharModalFinalizarTodas = () => { if (loadingFinalizarTodas) return; setModalFinalizarTodasAberto(false); };

  const finalizarTodasOrdens = async () => {
    setLoadingFinalizarTodas(true);
    try {
      const response = await axios.put(`${API_BASE_URL}/ordemservico/finalizarOrdemServicoDoDia`, {}, getAuthHeader());
      const resultado = response.data || {};
      if (resultado.enviados > 0) {
        addToast('success', `${resultado.enviados} ordem(ns) finalizada(s) com NFS-e emitida.`);
      }
      if (resultado.comErro > 0) {
        addToast('warning', `${resultado.comErro} ordem(ns) com erro na emissão - continuam abertas para reenvio.`);
      }
      if (!resultado.enviados && !resultado.comErro) {
        addToast('warning', 'Não havia ordens em aberto hoje para finalizar.');
      }
      setModalFinalizarTodasAberto(false);
      carregarOrdens();
      carregarContadores();
    } catch (err) {
      addToast('error', 'Erro ao finalizar ordens do dia: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoadingFinalizarTodas(false);
    }
  };

  if (loading) return <div style={styles.container}><Header /><div style={styles.loading}>Carregando ordens de serviço...</div></div>;
  if (error)   return <div style={styles.container}><Header /><div style={styles.error}>{error}</div></div>;

  return (
    <div style={styles.container}>
      <Header />
      <div style={styles.contentWrapper}>

        {/* ── Modal Finalização Individual (só confirmação) ── */}
        <Modal isOpen={modalFinalizacaoIsOpen} onRequestClose={fecharModalFinalizacao} style={modalFinalizacaoStyles} contentLabel="Finalizar Ordem">
          <div style={modalFinalizacaoStyles.header}>
            <h2 style={modalFinalizacaoStyles.title}><FaWallet style={{ marginRight: '10px' }} />Finalizar Ordem de Serviço</h2>
            <button onClick={fecharModalFinalizacao} style={modalFinalizacaoStyles.closeButton}><FaTimesCircle /></button>
          </div>
          {ordemParaFinalizar && (
            <div style={modalFinalizacaoStyles.modalBody}>
              <div style={modalFinalizacaoStyles.clienteSection}>
                <h3 style={modalFinalizacaoStyles.sectionTitle}>Dados do Cliente</h3>
                <div style={modalFinalizacaoStyles.clienteInfo}>
                  <div style={modalFinalizacaoStyles.infoRow}><FaUser style={modalFinalizacaoStyles.infoIcon} /><span><strong>Nome:</strong> {ordemParaFinalizar.clienteNome}</span></div>
                  <div style={modalFinalizacaoStyles.infoRow}><FaIdCard style={modalFinalizacaoStyles.infoIcon} /><span><strong>Documento:</strong> {ordemParaFinalizar.clienteDocumento}</span></div>
                  <div style={modalFinalizacaoStyles.infoRow}><FaMoneyBillWave style={modalFinalizacaoStyles.infoIcon} /><span><strong>Total a Pagar:</strong> R$ {parseFloat(ordemParaFinalizar.valorTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></div>
                </div>
              </div>
              <p style={modalFinalizacaoStyles.confirmacaoTexto}>
                Confirma a finalização desta ordem de serviço? Depois de finalizada, ela não poderá mais ser editada ou cancelada.
              </p>
              <div style={modalFinalizacaoStyles.buttons}>
                <button onClick={fecharModalFinalizacao} style={modalFinalizacaoStyles.cancelButton} disabled={finalizandoOrdem}>Cancelar</button>
                <button onClick={finalizarOrdem} disabled={finalizandoOrdem} style={{ ...modalFinalizacaoStyles.confirmButton, opacity: finalizandoOrdem ? 0.6 : 1 }}>
                  <FaWallet style={{ marginRight: '8px' }} />{finalizandoOrdem ? 'Gerando NFS-e...' : 'Finalizar Ordem'}
                </button>
              </div>
            </div>
          )}
        </Modal>

        {/* ── Modal Cancelamento com Motivo ── */}
        {modalCancelamentoAberto && (
          <div style={mc.overlay}>
            <div style={mc.modal}>
              <div style={mc.header}>
                <div style={mc.headerLeft}>
                  <FaBan size={20} style={{ color: '#fff' }} />
                  <div>
                    <h2 style={mc.title}>Cancelar Ordem de Serviço</h2>
                    <p style={mc.subtitle}>
                      {ordemParaCancelar && `#${ordemParaCancelar.numeroOrdem} — ${ordemParaCancelar.clienteNome}`}
                    </p>
                  </div>
                </div>
                <button onClick={fecharModalCancelamento} style={mc.closeBtn}>&times;</button>
              </div>
              <div style={mc.body}>
                <div style={mc.aviso}>
                  <strong>⚠️ Atenção:</strong> Esta ação é irreversível. A ordem cancelada não poderá mais ser editada ou finalizada.
                </div>
                <div style={mc.fieldGroup}>
                  <label style={mc.label}>
                    Motivo do cancelamento <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <textarea
                    value={motivoCancelamento}
                    onChange={(e) => setMotivoCancelamento(e.target.value)}
                    placeholder="Descreva o motivo do cancelamento desta ordem de serviço..."
                    rows={4}
                    style={mc.textarea}
                    maxLength={500}
                    autoFocus
                  />
                  <small style={mc.charCount}>{motivoCancelamento.length}/500 caracteres</small>
                </div>
              </div>
              <div style={mc.footer}>
                <button onClick={fecharModalCancelamento} style={mc.btnVoltar} disabled={loadingCancelamento}>Voltar</button>
                <button
                  onClick={confirmarCancelamento}
                  disabled={!motivoCancelamento.trim() || loadingCancelamento}
                  style={{ ...mc.btnConfirmar, opacity: (!motivoCancelamento.trim() || loadingCancelamento) ? 0.6 : 1, cursor: (!motivoCancelamento.trim() || loadingCancelamento) ? 'not-allowed' : 'pointer' }}
                >
                  <FaBan size={13} />
                  {loadingCancelamento ? 'Cancelando...' : 'Confirmar Cancelamento'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Modal Cancelamento de NFS-e ── */}
        {modalCancelamentoNfseAberto && (
          <div style={mc.overlay}>
            <div style={mc.modal}>
              <div style={mc.header}>
                <div style={mc.headerLeft}>
                  <FaBan size={20} style={{ color: '#fff' }} />
                  <div>
                    <h2 style={mc.title}>Cancelar NFS-e</h2>
                    <p style={mc.subtitle}>
                      {ordemParaCancelarNfse && `#${ordemParaCancelarNfse.numeroOrdem} — ${ordemParaCancelarNfse.clienteNome}`}
                    </p>
                  </div>
                </div>
                <button onClick={fecharModalCancelamentoNfse} style={mc.closeBtn}>&times;</button>
              </div>
              <div style={mc.body}>
                <div style={mc.aviso}>
                  <strong>⚠️ Atenção:</strong> Esta ação cancela a NFS-e junto à prefeitura e é irreversível. Não cancela nem altera o status da ordem de serviço.
                </div>
                <div style={mc.fieldGroup}>
                  <label style={mc.label}>Motivo do cancelamento</label>
                  <select value={cMotivoNfse} onChange={(e) => setCMotivoNfse(e.target.value)} style={mc.selectMotivo}>
                    <option value="1">Erro na Emissão</option>
                    <option value="2">Serviço não Prestado</option>
                    <option value="9">Outros</option>
                  </select>
                </div>
                <div style={mc.fieldGroup}>
                  <label style={mc.label}>
                    Descrição do motivo <span style={{ color: '#e74c3c' }}>*</span>
                  </label>
                  <textarea
                    value={xMotivoNfse}
                    onChange={(e) => setXMotivoNfse(e.target.value)}
                    placeholder="Descreva o motivo do cancelamento (mínimo 15 caracteres)..."
                    rows={4}
                    style={mc.textarea}
                    maxLength={255}
                    autoFocus
                  />
                  <small style={mc.charCount}>{xMotivoNfse.length}/255 caracteres (mínimo 15)</small>
                </div>

                {/* Escape valve: só aparece depois de uma tentativa de
                    cancelamento automático que falhou - ex.: P1001 do
                    Cidade360 ("está parametrizado para requisitar aprovação
                    desta operação"), que trava só o cancelamento via API mas
                    não o cancelamento direto no portal da prefeitura. */}
                {erroCancelamentoNfse && (
                  <div style={{ ...mc.aviso, background: '#fdecea', border: '1px solid #f5b7b1', color: '#922b21' }}>
                    <strong>O cancelamento automático falhou.</strong> Se você já cancelou esta NFS-e diretamente
                    no portal da prefeitura, informe o protocolo/requerimento abaixo para registrar o
                    cancelamento manualmente no sistema.
                    <div style={{ ...mc.fieldGroup, marginTop: 10 }}>
                      <label style={mc.label}>
                        Protocolo/requerimento na prefeitura <span style={{ color: '#e74c3c' }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={protocoloCancelamentoManual}
                        onChange={(e) => setProtocoloCancelamentoManual(e.target.value)}
                        placeholder="Número do protocolo/requerimento"
                        style={mc.selectMotivo}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div style={mc.footer}>
                <button onClick={fecharModalCancelamentoNfse} style={mc.btnVoltar} disabled={loadingCancelamentoNfse || loadingCancelamentoManual}>Voltar</button>
                {erroCancelamentoNfse && (
                  <button
                    onClick={confirmarCancelamentoManualNfse}
                    disabled={xMotivoNfse.trim().length < 15 || protocoloCancelamentoManual.trim().length === 0 || loadingCancelamentoManual}
                    style={{
                      ...mc.btnConfirmar,
                      background: 'linear-gradient(135deg, #d68910, #f39c12)',
                      opacity: (xMotivoNfse.trim().length < 15 || protocoloCancelamentoManual.trim().length === 0 || loadingCancelamentoManual) ? 0.6 : 1,
                      cursor: (xMotivoNfse.trim().length < 15 || protocoloCancelamentoManual.trim().length === 0 || loadingCancelamentoManual) ? 'not-allowed' : 'pointer',
                    }}
                  >
                    <FaBan size={13} />
                    {loadingCancelamentoManual ? 'Registrando...' : 'Cancelamento já feito na prefeitura'}
                  </button>
                )}
                <button
                  onClick={confirmarCancelamentoNfse}
                  disabled={xMotivoNfse.trim().length < 15 || loadingCancelamentoNfse || loadingCancelamentoManual}
                  style={{ ...mc.btnConfirmar, opacity: (xMotivoNfse.trim().length < 15 || loadingCancelamentoNfse || loadingCancelamentoManual) ? 0.6 : 1, cursor: (xMotivoNfse.trim().length < 15 || loadingCancelamentoNfse || loadingCancelamentoManual) ? 'not-allowed' : 'pointer' }}
                >
                  <FaBan size={13} />
                  {loadingCancelamentoNfse ? 'Cancelando...' : 'Confirmar Cancelamento'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Modal Ver Erro de NFS-e ── */}
        {modalErroNfseAberto && erroNfseSelecionado && (
          <div style={mc.overlay}>
            <div style={mc.modal}>
              <div style={{ ...mc.header, background: 'linear-gradient(135deg, #922b21, #c0392b)' }}>
                <div style={mc.headerLeft}>
                  <FaExclamationTriangle size={20} style={{ color: '#fff' }} />
                  <div>
                    <h2 style={mc.title}>Erro na NFS-e</h2>
                    <p style={mc.subtitle}>
                      {`#${erroNfseSelecionado.ordem.numeroOrdem} — ${erroNfseSelecionado.ordem.clienteNome}`}
                    </p>
                  </div>
                </div>
                <button onClick={fecharModalErroNfse} style={mc.closeBtn}>&times;</button>
              </div>
              <div style={mc.body}>
                <div style={styles.erroMensagemBox}>
                  {erroNfseSelecionado.mensagem || 'Erro não detalhado.'}
                </div>
              </div>
              <div style={mc.footer}>
                <button onClick={fecharModalErroNfse} style={mc.btnVoltar}>Fechar</button>
              </div>
            </div>
          </div>
        )}

        {/* ── Modal Finalizar Todas as Ordens do Dia (emite a NFS-e de cada uma) ── */}
        {modalFinalizarTodasAberto && (
          <div style={mft.overlay}>
            <div style={mft.modal}>
              <div style={mft.header}>
                <div style={mft.headerLeft}>
                  <FaCheckDouble size={20} style={{ color: '#fff' }} />
                  <div>
                    <h2 style={mft.title}>Finalizar Todas as Ordens do Dia</h2>
                    <p style={mft.subtitle}>Todas as ordens em aberto de hoje, {formatarData(dataLocalHoje())}, serão finalizadas com emissão de NFS-e</p>
                  </div>
                </div>
                <button onClick={fecharModalFinalizarTodas} style={mft.closeBtn}>&times;</button>
              </div>
              <div style={mft.body}>
                <div style={mft.aviso}>
                  <strong>⚠️ Atenção:</strong> Esta ação é irreversível e só funciona para as ordens de hoje. Cada ordem terá a NFS-e emitida
                  individualmente - se alguma falhar, ela continua aberta (com o erro registrado) e não impede as demais.
                </div>
              </div>
              <div style={mft.footer}>
                <button onClick={fecharModalFinalizarTodas} style={mft.btnCancelar} disabled={loadingFinalizarTodas}>Cancelar</button>
                <button onClick={finalizarTodasOrdens} disabled={loadingFinalizarTodas} style={{ ...mft.btnConfirmar, opacity: loadingFinalizarTodas ? 0.6 : 1, cursor: loadingFinalizarTodas ? 'not-allowed' : 'pointer' }}>
                  <FaCheckDouble size={14} />
                  {loadingFinalizarTodas ? 'Finalizando e emitindo NFS-e...' : `Finalizar Ordens de Hoje (${formatarData(dataLocalHoje())})`}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Cabeçalho ── */}
        <div style={styles.header}>
          <div style={styles.titleContainer}>
            <FaFileAlt style={styles.titleIcon} />
            <h1 style={styles.title}>ORDENS DE SERVIÇO</h1>
          </div>
          <div style={styles.buttonsContainer}>
            <button onClick={novaOrdem} style={styles.novaOrdemButton}><FaPlus style={{ marginRight: 8 }} />Nova Ordem</button>
            <button onClick={() => carregarOrdens()} style={styles.recarregarButton}><FaSync style={{ marginRight: 8 }} />Recarregar</button>
            {podeEditar && (
              <button onClick={abrirModalFinalizarTodas} style={styles.finalizarTodasButton}>
                <FaCheckDouble style={{ marginRight: 8 }} />Finalizar Todas as Ordens do Dia
              </button>
            )}
          </div>
        </div>

        {/* ── Filtros ── */}
        <div style={styles.filtrosContainer}>
          <div style={styles.filtrosHeader}>
            <FaFilter style={styles.filtrosIcon} />
            <h3 style={styles.filtrosTitle}>Filtros</h3>
            <button onClick={limparFiltros} style={styles.limparFiltrosButton}>Limpar Filtros</button>
          </div>
          <div style={styles.filtrosContent}>
            <div style={styles.filtroGrupo}>
              <label style={styles.filtroLabel}>Período:</label>
              <div style={styles.filtroInputs}>
                <input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') aplicarFiltros(); }} style={styles.filtroInput} max={dataLocalHoje()} />
                <span style={styles.ateLabel}>até</span>
                <input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') aplicarFiltros(); }} style={styles.filtroInput} max={dataLocalHoje()} />
              </div>
            </div>
            <div style={styles.filtroGrupo}>
              <label style={styles.filtroLabel}>Nome/CPF/CNPJ:</label>
              <div style={styles.filtroInputs}>
                <input type="text" value={filtroCpfCnpj} onChange={(e) => setFiltroCpfCnpj(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') aplicarFiltros(); }} placeholder="Nome, CPF ou CNPJ" style={styles.filtroInputText} />
              </div>
            </div>
            <div style={styles.filtroGrupo}>
              <label style={styles.filtroLabel}>Status:</label>
              <select value={filtroStatus} onChange={(e) => alterarFiltroStatus(e.target.value)} style={styles.filtroSelect}>
                <option value="TODOS">Todos os status</option>
                <option value="ABERTA">Aberta</option>
                <option value="CONCLUIDA">Concluída</option>
                <option value="CANCELADA">Cancelada</option>
              </select>
            </div>
            <div style={styles.filtroGrupo}>
              <span>&nbsp;</span>
              <button onClick={() => aplicarFiltros()} style={styles.aplicarFiltroButton}>
                <FaSearch style={{ marginRight: '5px' }} />Buscar
              </button>
            </div>
            <div style={styles.filtroGrupo}>
              <span>&nbsp;</span>
              <button onClick={filtrarOrdensDeHoje} style={{ ...styles.filtroRapidoButton, ...(mostrandoHoje ? styles.filtroRapidoButtonAtivo : {}) }}>
                <FaCalendarDay style={{ marginRight: '5px' }} />Ordens de Hoje
              </button>
            </div>
          </div>
          <div style={styles.filtroInfo}>
            {mostrandoHoje && <span style={styles.filtroTag}><FaCalendarDay /> Mostrando ordens de hoje</span>}
            {periodoAplicado && !mostrandoHoje && <span style={styles.filtroTag}><FaCalendarWeek /> Período: {formatarData(filtrosAplicados.dataInicio)} à {formatarData(filtrosAplicados.dataFim)}</span>}
            {!periodoAplicado && filtrosAplicados.termo && <span style={styles.filtroTag}><FaCalendarWeek /> Todas as datas</span>}
            {filtrosAplicados.termo && <span style={styles.filtroTag}><FaIdCard /> Nome/CPF/CNPJ: {filtrosAplicados.termo}</span>}
            {filtrosAplicados.status !== 'TODOS' && <span style={{ ...styles.filtroTag, backgroundColor: getStatusColor(filtrosAplicados.status).bg, color: getStatusColor(filtrosAplicados.status).text }}>Status: {filtrosAplicados.status.replace('_', ' ')}</span>}

            {/* ── Contadores: Qtd. O.S. / NFS-e geradas / O.S. em aberto / NFS-e c/ erro / O.S. canceladas ── */}
            <div style={styles.contadoresContainer}>
              <div style={{ ...styles.contadorCard, borderColor: '#3498db' }}>
                <span style={styles.contadorValor}>{carregandoContadores ? '—' : contadores.totalOS}</span>
                <span style={styles.contadorLabel}>Qtd. O.S.</span>
              </div>
              <div style={{ ...styles.contadorCard, borderColor: '#27ae60' }}>
                <span style={{ ...styles.contadorValor, color: '#27ae60' }}>{carregandoContadores ? '—' : contadores.nfseGeradas}</span>
                <span style={styles.contadorLabel}>NFS-e geradas</span>
              </div>
              <div style={{ ...styles.contadorCard, borderColor: '#0D47A1' }}>
                <span style={{ ...styles.contadorValor, color: '#0D47A1' }}>{carregandoContadores ? '—' : contadores.osAbertas}</span>
                <span style={styles.contadorLabel}>O.S. em aberto</span>
              </div>
              <div style={{ ...styles.contadorCard, borderColor: '#e67e22' }}>
                <span style={{ ...styles.contadorValor, color: '#e67e22' }}>{carregandoContadores ? '—' : contadores.nfseComErro}</span>
                <span style={styles.contadorLabel}>NFS-e c/ erro</span>
              </div>
              <div style={{ ...styles.contadorCard, borderColor: '#C62828' }}>
                <span style={{ ...styles.contadorValor, color: '#C62828' }}>{carregandoContadores ? '—' : contadores.osCanceladas}</span>
                <span style={styles.contadorLabel}>O.S. canceladas</span>
              </div>
            </div>
          </div>
        </div>

        {/* ── Lista de ordens ── */}
        <div style={styles.ordensContainer}>
          {ordensFiltradas.length === 0 ? (
            <div style={styles.noResults}>
              {temFiltroAplicado
                ? 'Nenhuma ordem encontrada com os filtros aplicados'
                : 'Nenhuma ordem de serviço cadastrada'}
            </div>
          ) : (
            ordensFiltradas.map((ordem, idx) => {
              const isCancelada = ordem.statusOrdemServico === 'CANCELADA';
              const isConcluida = ordem.statusOrdemServico === 'CONCLUIDA';
              const isAberta    = ordem.statusOrdemServico === 'ABERTA';
              // Motivo buscado individualmente via GET /{id}
              const motivo = isCancelada ? (motivosPorId[ordem.id] || null) : null;

              // NFS-e (não a OS) cancelada - some com Visualizar/DANFSe/Cancelar,
              // fica só o aviso. Vem de ordem.statusNfse (OrdemServicoCardDTO).
              const isNfseCancelada = isConcluida && ordem.statusNfse === 'CANCELADA';
              // Erro ao clicar Visualizar/DANFSe/Cancelar NFS-e - só local (some ao recarregar).
              const erroAcaoNfse = nfseErroPorId[ordem.id] || null;
              // Erro ao emitir a NFS-e ao finalizar a OS - persistido (ordem.erroNfse), só existe em OS ABERTA.
              const erroEmissaoNfse = ordem.erroNfse || null;
              const temErroNfseDestaque = !!(erroAcaoNfse || erroEmissaoNfse);
              // NFS-e emitida com sucesso (finalizada) - fundo verde, a não
              // ser que tenha um erro mais recente de ação pra destacar antes.
              const isNfseSucesso = isConcluida && !temErroNfseDestaque && ordem.statusNfse === 'AUTORIZADA';

              return (
                <div
                  key={ordem.id || ordem.idOrdemServico || idx}
                  style={{
                    ...styles.ordemCard,
                    ...(temErroNfseDestaque ? styles.ordemCardComErroNfse : {}),
                    ...(isNfseSucesso ? styles.ordemCardNfseSucesso : {}),
                  }}
                >
                  <div style={styles.ordemContent}>
                    <div style={styles.ordemHeader}>
                      <div style={styles.ordemInfo}>
                        <div style={styles.ordemNumero}>#{ordem.numeroOrdem}</div>
                        <div style={styles.ordemData}><FaCalendarAlt style={{ marginRight: 5 }} />{formatarData(ordem.dataCadastro)}</div>
                      </div>
                      <div style={{ ...styles.statusBadge, backgroundColor: getStatusColor(ordem.statusOrdemServico).bg, color: getStatusColor(ordem.statusOrdemServico).text }}>
                        {ordem.statusOrdemServico?.replace('_', ' ')}
                      </div>
                    </div>

                    <div style={styles.ordemBody}>
                      <div style={styles.clienteInfo}>
                        <FaUser style={styles.clienteIcon} />
                        <span style={styles.clienteNome}>{ordem.clienteNome}</span>
                        <span style={styles.clienteDocumento}><FaIdCard style={{ marginRight: 5 }} />{ordem.clienteDocumento}</span>
                      </div>
                      <div style={styles.veiculoInfo}>
                        <FaCar style={styles.veiculoIcon} />
                        <span>{ordem.quantidadeVeiculos} serviço(s)</span>
                      </div>
                      <div style={styles.valorTotal}>
                        <FaMoneyBillWave style={styles.valorIcon} />
                        <span>Total: R$ {parseFloat(ordem.valorTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>

                      {/* ── CORREÇÃO: exibe motivo de cancelamento ── */}
                      {isCancelada && motivo && (
                        <div style={styles.motivoCancelamento}>
                          <div style={styles.motivoHeaderRow}>
                            <FaBan size={10} style={{ color: '#c0392b', flexShrink: 0 }} />
                            <span style={styles.motivoLabel}>Motivo do cancelamento</span>
                          </div>
                          <span style={styles.motivoTexto}>"{motivo}"</span>
                        </div>
                      )}

                      {/* Sem motivo registrado (campo veio vazio da API) */}
                      {isCancelada && !motivo && (
                        <div style={styles.motivoAusente}>
                          <FaExclamationTriangle size={10} style={{ color: '#e67e22' }} />
                          <span>Motivo não registrado</span>
                        </div>
                      )}

                      {/* NFS-e (não a OS) cancelada */}
                      {isNfseCancelada && (
                        <div style={styles.nfseCanceladaAviso}>
                          <FaBan size={10} style={{ color: '#c0392b', flexShrink: 0 }} />
                          <span>A NFS-e desta ordem foi cancelada</span>
                        </div>
                      )}

                      {/* Erro na última ação de NFS-e (visualizar/DANFSe/cancelar) */}
                      {erroAcaoNfse && (
                        <div style={styles.nfseErroAviso}>
                          <FaExclamationTriangle size={10} style={{ color: '#c0392b', flexShrink: 0 }} />
                          <span>Falha na última ação de NFS-e desta ordem</span>
                        </div>
                      )}

                      {/* Erro ao emitir a NFS-e (OS não finalizou por causa disso) */}
                      {erroEmissaoNfse && (
                        <div style={styles.nfseErroAviso}>
                          <FaExclamationTriangle size={10} style={{ color: '#c0392b', flexShrink: 0 }} />
                          <span>Falha ao emitir a NFS-e desta ordem</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ── Coluna de ações ── */}
                  <div style={styles.botoesContainer}>

                    {/* Botões de ação para ordens ABERTAS */}
                    {isAberta && (
                      <div style={styles.statusButtons}>
                        <button onClick={() => abrirModalFinalizacao(ordem)} style={styles.concluirButton}>
                          <FaWallet style={{ marginRight: 5 }} />Finalizar
                        </button>
                        {podeEditar && (
                          <button onClick={() => abrirModalCancelamento(ordem)} style={styles.cancelarButton}>
                            <FaTimesCircle style={{ marginRight: 5 }} />Cancelar
                          </button>
                        )}
                      </div>
                    )}

                    {/* ── CORREÇÃO: botões de ação por status ──────────────── */}
                    {/* ABERTA: Editar + Imprimir (+ Ver erro, se a última tentativa de emitir a NFS-e falhou) */}
                    {isAberta && podeEditar && (
                      <div style={styles.acaoButtons}>
                        <button onClick={() => editarOrdem(ordem.id)} style={styles.editButton}><FaEdit /> Editar</button>
                        <button onClick={() => imprimirOrdem(ordem.id)} style={styles.printButton}><FaPrint /> Imprimir</button>
                        {erroEmissaoNfse && (
                          <button onClick={() => abrirModalErroNfse(ordem, erroEmissaoNfse)} style={styles.nfseErroButton}>
                            <FaExclamationTriangle /> Ver erro da NFS-e
                          </button>
                        )}
                      </div>
                    )}
                    {isAberta && !podeEditar && (
                      <div style={styles.acaoButtons}>
                        <button onClick={() => imprimirOrdem(ordem.id)} style={styles.printButton}><FaPrint /> Imprimir</button>
                        {erroEmissaoNfse && (
                          <button onClick={() => abrirModalErroNfse(ordem, erroEmissaoNfse)} style={styles.nfseErroButton}>
                            <FaExclamationTriangle /> Ver erro da NFS-e
                          </button>
                        )}
                      </div>
                    )}

                    {/* CONCLUÍDA: Imprimir + (Visualizar/DANFSe/Cancelar NFS-e OU badge de NFS-e cancelada) */}
                    {isConcluida && (
                      <div style={styles.acaoButtons}>
                        <button onClick={() => imprimirOrdem(ordem.id)} style={styles.printButton}><FaPrint /> Imprimir</button>

                        {erroAcaoNfse && (
                          <button onClick={() => abrirModalErroNfse(ordem, erroAcaoNfse)} style={styles.nfseErroButton}>
                            <FaExclamationTriangle /> Ver erro da NFS-e
                          </button>
                        )}

                        {isNfseCancelada ? (
                          <div style={styles.nfseCanceladaBadge}><FaBan size={12} /> NFS-e cancelada</div>
                        ) : (
                          <>
                            <button
                              onClick={() => visualizarNfse(ordem.id)}
                              disabled={nfseAcaoEmAndamento === `${ordem.id}:visualizar`}
                              style={{ ...styles.nfseVisualizarButton, opacity: nfseAcaoEmAndamento === `${ordem.id}:visualizar` ? 0.6 : 1 }}
                            >
                              <FaEye /> {nfseAcaoEmAndamento === `${ordem.id}:visualizar` ? 'Abrindo...' : 'Visualizar NFS-e'}
                            </button>
                            <button
                              onClick={() => imprimirDanfseNfse(ordem.id)}
                              disabled={nfseAcaoEmAndamento === `${ordem.id}:danfse`}
                              style={{ ...styles.nfseDanfseButton, opacity: nfseAcaoEmAndamento === `${ordem.id}:danfse` ? 0.6 : 1 }}
                            >
                              <FaFilePdf /> {nfseAcaoEmAndamento === `${ordem.id}:danfse` ? 'Gerando...' : 'Imprimir DANFSe'}
                            </button>
                            {podeEditar && (
                              <button onClick={() => abrirModalCancelamentoNfse(ordem)} style={styles.nfseCancelarButton}>
                                <FaBan /> Cancelar NFS-e
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    )}

                    {/* CANCELADA: SEM botão Imprimir — apenas badge de status */}
                    {/* (intencionalmente vazio — ordem cancelada não pode ser impressa) */}

                  </div>
                </div>
              );
            })
          )}
        </div>

        <ConfirmModal isOpen={confirmModal.isOpen} onClose={closeConfirm} onConfirm={confirmModal.onConfirm} title={confirmModal.title} message={confirmModal.message} confirmText={valorConfirm} cancelText="Sair" />

        {/* ── Paginação ── */}
        {ordensFiltradas.length > 0 && (
          <div style={styles.paginacaoContainer}>
            <div style={styles.paginacaoInfo}>Mostrando {ordensFiltradas.length} de {totalElementos} ordens</div>
            <div style={styles.paginacaoControles}>
              <select value={tamanhoPagina} onChange={(e) => alterarTamanhoPagina(Number(e.target.value))} style={styles.paginacaoSelect}>
                <option value={5}>5 por página</option>
                <option value={10}>10 por página</option>
                <option value={20}>20 por página</option>
                <option value={50}>50 por página</option>
              </select>
              <button onClick={irParaPrimeiraPagina} disabled={paginaAtual === 0} style={styles.paginacaoBotao}><FaStepBackward /></button>
              <button onClick={retrocederPagina}     disabled={paginaAtual === 0} style={styles.paginacaoBotao}><FaChevronLeft /></button>
              <span style={styles.paginacaoInfoPagina}>Página {paginaAtual + 1} de {totalPaginas}</span>
              <button onClick={avancarPagina}        disabled={paginaAtual >= totalPaginas - 1} style={styles.paginacaoBotao}><FaChevronRight /></button>
              <button onClick={irParaUltimaPagina}   disabled={paginaAtual >= totalPaginas - 1} style={styles.paginacaoBotao}><FaStepForward /></button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Estilos principais ───────────────────────────────────────────────────────

const styles = {
  container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f5f5f5', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" },
  contentWrapper: { paddingLeft: '35px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd', flexWrap: 'wrap', gap: 12 },
  titleContainer: { display: 'flex', alignItems: 'center', gap: '15px' },
  titleIcon: { fontSize: '28px', color: '#333' },
  title: { fontSize: '24px', margin: 0, color: '#333', fontWeight: '600' },
  buttonsContainer: { display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' },
  novaOrdemButton: { display: 'flex', alignItems: 'center', padding: '10px 15px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' },
  recarregarButton: { display: 'flex', alignItems: 'center', padding: '10px 15px', backgroundColor: '#2196F3', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' },
  finalizarTodasButton: { display: 'flex', alignItems: 'center', padding: '10px 18px', background: 'linear-gradient(135deg, #2c3e50, #34495e)', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', boxShadow: '0 2px 8px rgba(44,62,80,0.25)' },
  filtrosContainer: { backgroundColor: '#fff', margin: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', overflow: 'hidden' },
  filtrosHeader: { display: 'flex', alignItems: 'center', padding: '15px 20px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee' },
  filtrosIcon: { color: '#6c757d', marginRight: '10px' },
  filtrosTitle: { margin: 0, fontSize: '18px', color: '#333', flex: 1 },
  limparFiltrosButton: { padding: '5px 10px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
  filtrosContent: { padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' },
  filtroGrupo: { display: 'flex', flexDirection: 'column', gap: '8px' },
  filtroLabel: { fontWeight: '600', color: '#333', fontSize: '14px' },
  filtroInputs: { display: 'flex', alignItems: 'center', gap: '10px' },
  filtroInput: { padding: '8px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '14px' },
  filtroInputText: { padding: '8px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '14px', flex: 1 },
  ateLabel: { color: '#6c757d', fontSize: '14px' },
  aplicarFiltroButton: { padding: '8px 12px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
  filtroSelect: { padding: '8px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '14px', backgroundColor: 'white' },
  filtroRapidoButton: { display: 'flex', alignItems: 'center', padding: '8px 12px', backgroundColor: '#f8f9fa', color: '#212529', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
  filtroRapidoButtonAtivo: { backgroundColor: '#007bff', color: 'white', borderColor: '#007bff' },
  filtroInfo: { display: 'flex', gap: '10px', padding: '15px 20px', backgroundColor: '#f8f9fa', borderTop: '1px solid #eee', flexWrap: 'wrap', alignItems: 'center' },
  filtroTag: { display: 'flex', alignItems: 'center', gap: '5px', padding: '5px 10px', backgroundColor: '#e3f2fd', color: '#1976d2', borderRadius: '15px', fontSize: '14px', fontWeight: '500' },

  // ── Contadores do dia (Qtd. O.S. / NFS-e geradas / O.S. em aberto / NFS-e c/ erro) ──
  contadoresContainer: { display: 'flex', gap: 10, marginLeft: 'auto', flexWrap: 'wrap' },
  contadorCard: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '6px 14px', background: '#fff', border: '1.5px solid #ddd', borderRadius: 8, minWidth: 90 },
  contadorValor: { fontSize: 18, fontWeight: 700, color: '#2c3e50' },
  contadorLabel: { fontSize: 10, color: '#7f8c8d', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.3, textAlign: 'center' },

  ordensContainer: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))', gap: '20px', padding: '0 20px 20px 20px', flex: 1 },
  ordemCard: { backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', overflow: 'hidden', display: 'flex', flexDirection: 'row', minHeight: '160px', width: '100%' },
  ordemCardComErroNfse: { backgroundColor: '#fff5f5', boxShadow: '0 2px 4px rgba(192,57,43,0.25)', border: '1px solid #f1948a' },
  ordemCardNfseSucesso: { backgroundColor: '#f0fbf4', boxShadow: '0 2px 4px rgba(39,174,96,0.2)', border: '1px solid #a9e3bf' },
  ordemContent: { flex: 1, display: 'flex', flexDirection: 'column', padding: '15px', gap: '10px' },
  ordemHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px' },
  ordemInfo: { display: 'flex', flexDirection: 'column', gap: '5px' },
  ordemNumero: { fontWeight: '600', color: '#2c3e50', fontSize: '16px' },
  ordemData: { display: 'flex', alignItems: 'center', fontSize: '13px', color: '#7f8c8d' },
  statusBadge: { padding: '4px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '600', flexShrink: 0 },
  ordemBody: { display: 'flex', flexDirection: 'column', gap: '8px', flex: 1, justifyContent: 'center' },
  clienteInfo: { display: 'flex', flexDirection: 'column', gap: '3px' },
  clienteIcon: { color: '#3498db', marginRight: '5px', fontSize: '14px' },
  clienteNome: { fontWeight: '600', fontSize: '15px', color: '#2c3e50' },
  clienteDocumento: { display: 'flex', alignItems: 'center', fontSize: '13px', color: '#7f8c8d' },
  veiculoInfo: { display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#555' },
  veiculoIcon: { color: '#e74c3c', fontSize: '14px' },
  valorTotal: { display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600', color: '#2ecc71', fontSize: '15px' },
  valorIcon: { fontSize: '14px' },

  // ── Motivo de cancelamento ─────────────────────────────────────────────────
  motivoCancelamento: {
    display: 'flex', flexDirection: 'column', gap: 4,
    marginTop: 6, padding: '8px 12px',
    background: '#fff5f5',
    border: '1px solid #fcc',
    borderLeft: '3px solid #e74c3c',
    borderRadius: 6,
  },
  motivoHeaderRow: { display: 'flex', alignItems: 'center', gap: 5 },
  motivoLabel: { fontSize: '10px', fontWeight: 700, color: '#c0392b', textTransform: 'uppercase', letterSpacing: 0.4 },
  motivoTexto: { fontSize: '12px', color: '#555', fontStyle: 'italic', lineHeight: 1.5 },
  motivoAusente: { display: 'flex', alignItems: 'center', gap: 5, fontSize: '11px', color: '#e67e22', fontStyle: 'italic', marginTop: 4 },

  // ── NFS-e cancelada / erro em ação de NFS-e ───────────────────────────────
  nfseCanceladaAviso: { display: 'flex', alignItems: 'center', gap: 5, marginTop: 6, padding: '6px 10px', background: '#fff5f5', border: '1px solid #fcc', borderLeft: '3px solid #c0392b', borderRadius: 6, fontSize: '11px', color: '#922b21', fontWeight: 600 },
  nfseErroAviso: { display: 'flex', alignItems: 'center', gap: 5, marginTop: 6, padding: '6px 10px', background: '#fff5f5', border: '1px solid #fcc', borderLeft: '3px solid #e67e22', borderRadius: 6, fontSize: '11px', color: '#922b21', fontWeight: 600 },
  nfseCanceladaBadge: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '8px 12px', backgroundColor: '#f5e0de', color: '#922b21', borderRadius: '4px', fontSize: '12px', fontWeight: '700', width: '100%', boxSizing: 'border-box' },
  nfseErroButton: { padding: '8px 12px', backgroundColor: '#e67e22', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', fontSize: '12px', width: '100%' },
  erroMensagemBox: { background: '#fff5f5', border: '1px solid #f1948a', borderRadius: 8, padding: '14px 16px', fontSize: 13, color: '#922b21', lineHeight: 1.6, whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: '40vh', overflowY: 'auto' },

  botoesContainer: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '15px', borderLeft: '1px solid #eee', minWidth: '150px', flexShrink: 0, gap: '10px' },
  statusButtons: { display: 'flex', flexDirection: 'column', gap: '8px' },
  concluirButton: { padding: '8px 12px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '600', width: '100%' },
  cancelarButton: { padding: '8px 12px', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '600', width: '100%' },
  statusInfo: { padding: '6px 10px', borderRadius: '6px', textAlign: 'center', fontSize: '12px', fontWeight: '600' },
  acaoButtons: { display: 'flex', flexDirection: 'column', gap: '8px' },
  editButton: { padding: '8px 12px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', fontSize: '12px', width: '100%' },
  printButton: { padding: '8px 12px', backgroundColor: '#95a5a6', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', fontSize: '12px', width: '100%' },
  nfseVisualizarButton: { padding: '8px 12px', backgroundColor: '#16a085', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', fontSize: '12px', width: '100%' },
  nfseDanfseButton: { padding: '8px 12px', backgroundColor: '#8e44ad', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', fontSize: '12px', width: '100%' },
  nfseCancelarButton: { padding: '8px 12px', backgroundColor: '#c0392b', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', fontSize: '12px', width: '100%' },
  loading: { padding: '40px', textAlign: 'center', fontSize: '18px', color: '#7f8c8d' },
  error: { padding: '40px', textAlign: 'center', fontSize: '18px', color: '#e74c3c' },
  noResults: { gridColumn: '1 / -1', padding: '40px', textAlign: 'center', fontSize: '16px', color: '#7f8c8d', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
  paginacaoContainer: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 20px', backgroundColor: '#fff', borderTop: '1px solid #eee', margin: '0 20px 20px 20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
  paginacaoInfo: { fontSize: '14px', color: '#666', fontWeight: '500' },
  paginacaoControles: { display: 'flex', alignItems: 'center', gap: '10px' },
  paginacaoSelect: { padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: 'white', fontSize: '14px' },
  paginacaoBotao: { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px 12px', border: '1px solid #ddd', backgroundColor: 'white', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', color: '#333' },
  paginacaoInfoPagina: { fontSize: '14px', color: '#333', fontWeight: '500', margin: '0 10px' },
};

// ─── Modal Cancelamento ───────────────────────────────────────────────────────
const mc = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1100 },
  modal: { background: '#fff', borderRadius: 14, width: '92%', maxWidth: 500, boxShadow: '0 16px 50px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '20px 24px', background: 'linear-gradient(135deg, #c0392b, #e74c3c)', color: '#fff' },
  headerLeft: { display: 'flex', alignItems: 'flex-start', gap: 14 },
  title: { margin: '0 0 4px', fontSize: 17, fontWeight: 700, color: '#fff' },
  subtitle: { margin: 0, fontSize: 12, color: 'rgba(255,255,255,0.85)' },
  closeBtn: { background: 'none', border: 'none', color: '#fff', fontSize: 26, cursor: 'pointer', lineHeight: 1, padding: 0 },
  body: { padding: '22px 24px', display: 'flex', flexDirection: 'column', gap: 16 },
  aviso: { background: '#fff8e1', border: '1px solid #ffe082', borderRadius: 8, padding: '12px 16px', fontSize: 12, color: '#7c5000', lineHeight: 1.6 },
  fieldGroup: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 13, fontWeight: 700, color: '#333' },
  selectMotivo: { padding: '10px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', outline: 'none', width: '100%', boxSizing: 'border-box', backgroundColor: '#fff' },
  textarea: { padding: '10px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8, fontSize: 13, resize: 'vertical', fontFamily: 'inherit', outline: 'none', width: '100%', boxSizing: 'border-box', minHeight: 100 },
  charCount: { fontSize: 11, color: '#aaa', textAlign: 'right' },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 12, padding: '16px 24px', borderTop: '1px solid #f0f0f0', background: '#fafafa' },
  btnVoltar: { padding: '10px 20px', background: '#f0f0f0', color: '#555', border: '1px solid #ddd', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  btnConfirmar: { display: 'flex', alignItems: 'center', gap: 8, padding: '10px 22px', background: 'linear-gradient(135deg, #c0392b, #e74c3c)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700 },
};

// ─── Modal Finalizar Todas ────────────────────────────────────────────────────
const mft = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1100 },
  modal: { background: '#fff', borderRadius: 14, width: '92%', maxWidth: 520, boxShadow: '0 16px 50px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '20px 24px', background: 'linear-gradient(135deg, #2c3e50, #34495e)', color: '#fff' },
  headerLeft: { display: 'flex', alignItems: 'flex-start', gap: 14 },
  title: { margin: '0 0 4px', fontSize: 17, fontWeight: 700, color: '#fff' },
  subtitle: { margin: 0, fontSize: 12, color: 'rgba(255,255,255,0.85)' },
  closeBtn: { background: 'none', border: 'none', color: '#fff', fontSize: 26, cursor: 'pointer', lineHeight: 1, padding: 0 },
  body: { padding: '22px 24px', display: 'flex', flexDirection: 'column', gap: 20 },
  fieldGroup: { display: 'flex', flexDirection: 'column', gap: 8 },
  label: { fontSize: 12, fontWeight: 700, color: '#444', textTransform: 'uppercase', letterSpacing: 0.4, display: 'flex', alignItems: 'center' },
  dateInput: { padding: '10px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8, fontSize: 14, outline: 'none', width: '100%', boxSizing: 'border-box' },
  hint: { fontSize: 11, color: '#aaa', fontStyle: 'italic' },
  aviso: { background: '#fff8e1', border: '1px solid #ffe082', borderRadius: 8, padding: '12px 16px', fontSize: 12, color: '#7c5000', lineHeight: 1.6 },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 12, padding: '16px 24px', borderTop: '1px solid #f0f0f0', background: '#fafafa' },
  btnCancelar: { padding: '10px 20px', background: '#f0f0f0', color: '#555', border: '1px solid #ddd', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  btnConfirmar: { display: 'flex', alignItems: 'center', gap: 8, padding: '10px 22px', background: 'linear-gradient(135deg, #2c3e50, #34495e)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700 },
};

// ─── Modal Finalização Individual ────────────────────────────────────────────
const modalFinalizacaoStyles = {
  overlay: { backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1001 },
  content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', maxWidth: '460px', width: '90%', maxHeight: '90vh', borderRadius: '12px', padding: '0', boxShadow: '0 10px 30px rgba(0,0,0,0.2)', border: 'none', overflow: 'hidden' },
  modalBody: { padding: '25px', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 25px', borderBottom: '1px solid #eee', backgroundColor: '#f8f9fa' },
  title: { margin: 0, color: '#2c3e50', fontSize: '20px', display: 'flex', alignItems: 'center', fontWeight: '600' },
  closeButton: { background: 'none', border: 'none', fontSize: '22px', color: '#7f8c8d', cursor: 'pointer' },
  clienteSection: { marginBottom: '20px' },
  sectionTitle: { margin: '0 0 15px 0', color: '#2c3e50', fontSize: '16px', fontWeight: '600', borderBottom: '2px solid #3498db', paddingBottom: '8px' },
  clienteInfo: { backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px', border: '1px solid #e9ecef' },
  infoRow: { display: 'flex', alignItems: 'center', marginBottom: '10px', fontSize: '14px', color: '#2c3e50' },
  infoIcon: { marginRight: '10px', color: '#3498db', width: '16px' },
  confirmacaoTexto: { fontSize: '13px', color: '#555', lineHeight: 1.6, margin: '0 0 20px 0' },
  buttons: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '20px' },
  cancelButton: { padding: '12px 24px', backgroundColor: '#f8f9fa', color: '#6c757d', border: '1px solid #dee2e6', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' },
  confirmButton: { padding: '12px 24px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px', display: 'flex', alignItems: 'center' },
};

export default OrdemServicoView;
